import getUrl from "@/Helpers/BaseUrl";
import axios from "axios";
export async function getPermissions() {
    const response = await axios.get(getUrl(`/eci/v1/crmweb/Permissions`));
    return response.data;
}
